import axios from 'axios';

export const isAlertExempted = data => {
  const {
    data: { message = '', error }
  } = data;

  const exemptionMessages = [
    'Invalid Token',
    'User does not exist',
    'Incorrect password'
  ];

  return !(
    !exemptionMessages.includes(message) && !exemptionMessages.includes(error)
  );
};

export const sendSlackAlert = async (data, env) => {
  const slackWebHookURL =
    env === 'prod'
      ? 'https://hooks.slack.com/services/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'
      : 'https://hooks.slack.com/services/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';
  const {
    status,
    config: { url, method, data: requestData },
    data: { message = '', error },
    email
  } = data;

  const isRequestDataVisible =
    url.indexOf('login') === -1 && url.indexOf('register') === -1;

  const notificationBody = {
    username: 'API Error',
    icon_emoji: ':bangbang:',
    attachments: [
      {
        color: '#ff0000',
        fields: [
          {
            title: 'Environment',
            value: env,
            short: true
          },
          {
            title: 'HTTP Status',
            value: status,
            short: true
          },
          {
            title: 'Error',
            value: error,
            short: true
          },
          {
            title: 'Method',
            value: method.toUpperCase(),
            short: true
          },
          {
            title: 'API',
            value: url,
            short: true
          },
          {
            title: 'Message',
            value: message,
            short: true
          },
          {
            title: 'User',
            value: email,
            short: true
          },
          {
            title: 'API Request',
            value: isRequestDataVisible ? requestData : '',
            short: false
          }
        ],
        image_url: 'http://my-website.com/path/to/image.jpg',
        thumb_url: 'http://example.com/path/to/thumb.png',
        ts: +new Date()
      }
    ]
  };

  try {
    await axios.post(slackWebHookURL, JSON.stringify(notificationBody), {
      withCredentials: false,
      transformRequest: [
        (returnData, headers) => {
          // eslint-disable-next-line no-param-reassign
          delete headers.post['Content-Type'];
          return returnData;
        }
      ]
    });
  } catch (err) {
    throw err;
  }
};
